import type { GetServerSideProps } from 'next/types';
import dynamic from 'next/dynamic';
import { DealsCollectionPageProps } from '@/components/collections-v3/hooks/types';
import { fetchDeals, fetchFeaturedDeals } from '@/lib/backend/collections';
import { CollectionPageProvider } from '@/components/collections-v3/hooks/useCollectionPageContext';

// Fills the screen while the chunk loads on a client-side navigation, so the
// footer doesn't jump into view and back (RT-17488).
const CollectionPageLayout = dynamic(
  () => import('@/components/collections-v3/CollectionPageLayout'),
  {
    ssr: true,
    loading: () => <div className="min-h-screen" />,
  },
);

export const getServerSideProps: GetServerSideProps<
  DealsCollectionPageProps
> = async (context) => {
  const { skus, total, filters, searchParams } = await fetchDeals({
    urlParams: context.query,
  });

  const { skus: spotlightedProducts } = await fetchFeaturedDeals();

  const props: DealsCollectionPageProps = {
    products: skus,
    spotlightedProducts,
    filters,
    total,
    collectionName: 'Deals',
    breadcrumb: null, // Exclusive for Category Collection Pages
    pk: null, // Exclusive for Category Collection Pages
    fixedFilters: {},
    searchParams,
    handle: null, // Exclusive for Nav Collection Pages
    msCatalogEnabled: true,
    type: 'MS_CATALOG_DEALS',
  };

  return {
    props,
  };
};

export default function Deals(props: DealsCollectionPageProps) {
  return (
    <CollectionPageProvider props={props} key={props.handle}>
      <CollectionPageLayout />
    </CollectionPageProvider>
  );
}
